import {
  Table as CXTable,
  TableCell as CXTableCell,
  TableSortLabel as CXTableSortLabel,
  TableBody as CXTableBody,
  TableContainer as CXTableContainer,
  TableHead as CXTableHead,
  TableRow as CXTableRow,
  TablePagination as CXTablePagination,
  ITableSortLabel as CXITableSortLabel,
  ITableCell as CXITableCell
} from '@sanlamcx/react-ui-next-table';

type Table = typeof CXTable;
type TableCell = typeof CXTableCell;
type TableSortLabel = typeof CXTableSortLabel;

export type ITableCell = CXITableCell;
export type ITableSortLabel = CXITableSortLabel;

export const Table: Table = CXTable;
export const TableContainer = CXTableContainer;
export const TableRow = CXTableRow;
export const TableHead = CXTableHead;
export const TableCell: TableCell = CXTableCell;
export const TableBody = CXTableBody;
export const TableSortLabel: TableSortLabel = CXTableSortLabel;
export const TablePagination = CXTablePagination;

export const DIRECTION = {
  ASC: 'asc',
  DESC: 'desc'
} as const;
export type IDirection = (typeof DIRECTION)[keyof typeof DIRECTION];
